import React from 'react';

import { CreditLineCheckoutSummary, CreditLineCheckoutSummaryProps } from '../credit-line-checkout-summary/component';

import './style.scss';

export type CreditLineCheckoutPageBannerProps = CreditLineCheckoutSummaryProps;

export function CreditLineCheckoutPageBanner(props: CreditLineCheckoutPageBannerProps) {
  return (
    <div className="credit-line-checkout-page-banner">
      <div className="credit-line-checkout-page-banner__inner">
        <CreditLineCheckoutSummary {...props} />
      </div>
    </div>
  );
}
